<template>
    <iframe src="https://app.getbeamer.com/harnessgiving/requests" width="100%" class="container-height" style="border: 0;padding: 0;margin: 0">
    </iframe>
</template>

<script>
  export default {
    name: 'RequestFeature',
    metaInfo: {
      title: 'Request Feature',
    },
  };
</script>

